import { api } from "../../services/Api.js";

export function get_push_notes({ commit, state }, payload ){

    // adding token
    payload.token=state.appSettings.token

   
    // get active school
    var school = state.user_schools.find(school => school.active === 1);

    // retrun chainable promise
    return api
    .post(school,"get_push_notes.php",payload)
    .then( result =>{ 
      
      // list of push notes from user
      commit('SET_PUSH_NOTES', result.data.items);
      return result.items
    })
    .catch( error => {
      //console.log("ERROR GETTING CALENDAR",error);
      return error;
    })

}